import React from 'react';
import { Provider } from 'react-redux';
import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';
import './index.scss';

import { config } from '@triare/auth-redux';

import store from './store';
import Routes from './routes';
import AntdConfigProvider from './AntdConfigProvider';
import { ArticleProvider } from './components/Common/Header/context';
import { ProductProvider } from './context/products';

const { displayName } = config;

dayjs.extend(localeData);

export default function App(): React.ReactNode {
  document.title = `${displayName}`;

  return (
    <Provider store={store}>

      <ProductProvider>
        <AntdConfigProvider>
          <ArticleProvider>
            <Routes />
          </ArticleProvider>
        </AntdConfigProvider>
      </ProductProvider>

    </Provider>
  );
}
